import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from '../CategoryBar.module.css';


const IconEntertainment = props => {
  const { rootClassName, className, pencilClassName } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg className={classes} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" >
      <rect width="32" height="32" fill="url(#pattern0_2201_23664)"/>
      <defs>
        <pattern id="pattern0_2201_23664" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_2201_23664" transform="scale(0.02)"/>
        </pattern>
        <image id="image0_2201_23664" width="50" height="50" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFb0lEQVR4nNVZa4xdUxTeU89UEM8oDf0hQUo85odHyCXm3rO/b59cI3LrkRShitGi1VS85iL8I/wQQkIyIQgTodKqIOJV/GBIGkXQekS0wh+PZlqdkWXWbnaOc+77nntnJSfn3nPWPmd9e6/1rbXXMaYPxDlXMbNdisXifiR/K5VKB5vZLCSvJDktZzObBcC7CmSt6TcheUShUNiznl6pVDqW5JQAATDpnDvI9JPEcXw0gE3OuStqAQJwn67GdCPuVSgU9gWwxDl3lMlLSD6jM/01ycWVSmWP8H61Wp1D8gcF8FQt97LWHkaySnIryddNnuKcO9m7jQLaRPJSAaDGlTzQ4eHhQ0juSLpXHMfHA3gcwN/+OdbaM0zeAmB9wnXk2Ch5g+TzCuR20SW5zruXc+5ckq8C2JUY2xtCsNaerwZsA3AdgO9CwwD8Y62dn6Dh7YHOdgAv6+8p59yg6ZUA+ESNXjI4OLiXnAFs0WvrvZ64FIBJNfpnkndqbDyoui/1DIQaeImPER8flUplb1khay1DXQAPAbhc7sv/crl8pMSHuBiAk0wvRdiK5Dc60xc0M5bkozoJz5k+AHEegA0K5P1Gx0ZRtCBwtdNNL4zXIH9MeT9knS+jKJoHIAbwNsmvSI75gA+F5MMBKQj9jjnnzjHdFAlizQtPAPg1SbcA7nbOnagG3p+kZAC/kzwr+Uzn3IVCucJuiXy0qlgsHt5REFEULQQwkWLchLX21IySZKdzbmkURccBeEWv/Sm1V9o7ZMVIjnq287UZyRcBIFk1tCzCRgCKEpRhHtCZfkQAAbjH5w4AF/uxYgSAp3XMWMZkzbPWXk/yrcRkScJ8D8BFptMiGySSywF8lrJKAuKyFEMXqs7n/hrJY0iuEIJIZPidJN8kOSL0bPIQycQAvg1mb3GaHoDb1Mg1wTW/Sj7br5HsL3VZLsYnDLwrAJFaoqvLTImOC1iJ5CkKYkeuZXtSSN4RgLg6Q2dEK+QpAVTVzB/c9zGxwvRCAleRQm9phs4NIYg4jg+VohLAMmvtPqoT63M2N7Lj7DSIlR6EGJumI+A8CK+jgT2tx1bn3K1xHM8F8IVcy7VlJInKgxDmytBZHuzTJ4LrG/Xa9wHL/QTgA/29Ie+VkOPDpL+rsTf6lZAglrPs7yWr67gfxYUkLwgVJ+k7juMzuwqC5LUJqpTzkyGYEIQy1bjO9Mpgz35v8NgBKVHCfATgha6BsNZepcwk/n6TtfZskn+EYOR6CELGSXb3SVDKE3lGFEULUl4xAGCY5KeSDDN02hOhVQ/CG6jgdoMB8FEShG+VAvgrmO3du8UMGZD9jGy8cgGRAOPdLFVHij4PpCeNbNYBIaLulAlCRLsp/zUn/PY2N9HmQU0QvuyoRcMikickPkg+YPoZhLX25nrP1P7WCSYvAXBNMyDEtRp5btZmKtxUpW2F246JrLIjBJoFolwu709yUZPvHpUq2rQrYV3U7kqIHoCPG313dSYHbZEjrVLoGgjJ3lnPkvJCuijaiJZqd26995O0QcVgewpCK9hnU5rZm2XzVAfIeKA/3mrtNNUJim11RSJt0Gm7VI7JpsqTkGIbCexa7pS2I5SSJet+tVqd45wbkuIw6DKuA/Ba0Lx4QxJpzY2WNJabDOxljYLQsQdIU7vBvtUuARDH8WlyyO+wm6K6o/+j5m6DqAOwM0DsTK+2GRCpLteuVGe+KwpTjXvXUgDetSaVAGwqHQffulf1CkRHgp3kNgEyNDR0YB12Gumm8W3Tr/9+AWB1v4BoKSFKAzpwndX6Pe+WenHTbam2UqIE+SPMvh1lp1aErRSNwl4A3gHwi3TBJTl1zcLGbZrfsTJ+Nsi/9rBstWsjr3IAAAAASUVORK5CYII="/>
      </defs>
    </svg>
  );
};

IconEntertainment.defaultProps = {
  rootClassName: null,
  className: null,
  pencilClassName: null,
};

const { string } = PropTypes;

IconEntertainment.propTypes = {
  rootClassName: string,
  className: string,
  pencilClassName: string,
};

export default IconEntertainment;
